import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "status-description" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = ["innerHTML"]

import {
  TimelineMilestone,
  TimelineMilestoneIds,
  titleDictionary,
} from "@/models/applicationStatus";
import { computed } from "vue";
import { useStore } from "vuex";
import NextButton from "@/components/shared/NextButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TimelineStepDescription',
  props: {
  step: {
    type: Number,
  },
  status: {
    type: String,
  },
  mobile: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["viewCertificationUpdates"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const props = __props;

const emit = __emit;

const statuses = computed<TimelineMilestone[]>(() => {
  return store.state.applicationStatusModule.timeline;
});

const title = computed(() => {
  switch (props.status) {
    case "active":
      return "Current Step";
    case "complete":
      return "Completed";
    default:
      return "";
  }
});

const statusHeader = computed<string>(
  () => statuses.value.find((t: TimelineMilestone) => t.step === props.step)?.title || "",
);

const statusDescription = computed<string>(
  () => statuses.value.find((t: TimelineMilestone) => t.step === props.step)?.description || "",
);

const statusDescriptionHtml = computed<string>(() => {
  const step = statuses.value.find((t: TimelineMilestone) => t.step === props.step);

  return step?.html || step?.descriptionHtml || "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["title", __props.status])
    }, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createTextVNode(_toDisplayString(title.value), 1)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _createTextVNode(_toDisplayString(statusHeader.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (statusDescriptionHtml.value && !statusDescription.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: statusDescriptionHtml.value
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "description", {}, () => [
        _createElementVNode("p", null, _toDisplayString(statusDescription.value), 1)
      ]),
      _renderSlot(_ctx.$slots, "default"),
      (statusHeader.value === _unref(titleDictionary)[_unref(TimelineMilestoneIds).SCHOOL_CERTIFICATION])
        ? (_openBlock(), _createBlock(NextButton, {
            key: 1,
            text: "View Certification Updates",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('viewCertificationUpdates')), ["prevent"])),
            id: "view-certification-updates-btn"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})